import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	EnhancedDropDownRHFWithLabel,
	LabelPosition,
	RHookFormDatePicker,
} from "@websential/cosmic-v20";
import { Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";



interface ICRAReportHeader {
	companySavedRemittance: { label: string, value: string };
}

export const CRAReportHeader: React.FC<
	ICRAReportHeader
> = ({ companySavedRemittance }) => {

	return (
		<>
			<Grid
				container
				size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
				sx={{
					background: "#fff",
					border: "1px solid #e5e7eb",
					borderBottom: 0,
					borderRadius: "2px 2px 0 0",
					padding: "3rem 0px 0.8rem 0.8rem",
				}} columnSpacing={2}>
				<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} sx={{ color: "#fff" }}>

					<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} sx={{ color: "rgba(49, 7, 7, 0.6)", fontSize: "0.875rem" }}>

						<Typography
							sx={{
								fontSize: ".875rem",
								color: "rgba(0, 0, 0, 0.62)",
								fontWeight: 600,
								marginBottom: "1rem",

							}}>
							Remittance Type:
							<span style={{
								color: "#0091b3",
								fontWeight: "bold",
								fontSize: "0.875rem",
							}}>&nbsp;&nbsp; {companySavedRemittance && companySavedRemittance.label}</span>
						</Typography>
					</Grid>
				</Grid>

			</Grid>

		</>
	);
};
